export default {
  methods: {
    getNormalized (client) {
      let normalized = client
      if (client.client && client.client.first_name) {
        normalized = client.client
      }
      return normalized
    },
    getfullName (client) {
      let fname = ''
      if (client.first_name) { fname = client.first_name }
      if (client.last_name) { fname += (' ' + client.last_name) }
      return fname
    },
    asRecipient (client) {
      let normalized = this.getNormalized(client)
      let userId = this.getObjectPath(client, 'client.id', null)
      let data = {
        relationship_id: client.id,
        full_name: this.getfullName(normalized),
        first_name: normalized.first_name,
        last_name: normalized.last_name,
        email: normalized.email,
        phone_number: normalized.phone_number
      }
      if (userId) { data['user_id'] = userId }
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/client.js